import { render, staticRenderFns } from "./homepage.tb.pellegrini.vue?vue&type=template&id=17481e72&scoped=true&"
import script from "./homepage.tb.pellegrini.vue?vue&type=script&lang=js&"
export * from "./homepage.tb.pellegrini.vue?vue&type=script&lang=js&"
import style0 from "./homepage.tb.pellegrini.vue?vue&type=style&index=0&id=17481e72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17481e72",
  null
  
)

export default component.exports